import get from 'lodash/get'

import PoziDataTransformer from 'api/data-transformer'

export default function (layer, geojson, coords) {
  if (layer.config.transformer) {
    // console.log('config geojson transform')
    PoziDataTransformer().transform(layer.config, geojson, coords)

    const features = get(geojson, 'features', [])
    for (const fkey in features) {
      const feature = features[fkey]
      feature.properties = PoziDataTransformer().transform(layer.config, feature.properties, coords)
    }
  }
  return geojson
}
